const state = {
  page: localStorage.getItem('page') ? localStorage.getItem('page') : 'login'
}

const mutations = {
  change_page (state, page) {
    state.page = page
    localStorage.setItem('page', page)
  }
}

const getters = {
  page () {
    return state.page
  }
}

export default {
  state,
  mutations,
  getters
}
